import { useFeliz_React__React_useState_Static_1505 } from "../../../../src/fable_modules/Feliz.1.68.0/React.fs.js";
import { now } from "../../../../src/fable_modules/fable-library.3.7.18/Date.js";
import { MuiXHelpers_createElement } from "../../../../../src/Feliz.MuiX.DatePickers/./Mui.fs.js";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { MuiHelpers_createElement } from "../../../../../src/Feliz.MaterialUI/./Mui.fs.js";
import { TextField, Container } from "@mui/material";
import { Interop_reactApi } from "../../../../src/fable_modules/Feliz.1.68.0/./Interop.fs.js";

export function DateTimePickersSample(dateTimePickersSampleInputProps) {
    let value, elements_1, elements;
    const key = dateTimePickersSampleInputProps.$key;
    const patternInput = useFeliz_React__React_useState_Static_1505(now());
    return MuiXHelpers_createElement(LocalizationProvider, [(value = AdapterDateFns, ["dateAdapter", value]), (elements_1 = [MuiHelpers_createElement(Container, [(elements = [MuiXHelpers_createElement(DateTimePicker, [["ampm", false], ["inputFormat", "dd.MM.yyyy HH:mm"], ["onChange", (delegateArg, delegateArg_1) => {
        patternInput[1](delegateArg);
    }], ["renderInput", (delegateArg_2) => MuiHelpers_createElement(TextField, Object.entries(delegateArg_2))], ["value", patternInput[0]]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])]);
}

